import { Button, ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import { IconLayoutGrid, IconQrcode, IconSquarePlus, IconTable, IconX } from "@tabler/icons-react";
import type { VisualizacionInventario } from "../types/catalogoInventario.types";
import { COLORES_INVENTARIO } from "../constants/catalogoInventario.constants";

interface Props {
    visualizacion: VisualizacionInventario;
    onCambiarVisualizacion: (v: VisualizacionInventario) => void;
    textoAnadir: string;
    onAnadir: () => void;
    /* QR masivo, los botones solo aparecen si hay productos seleccionados */
    seleccionados: number;
    generandoQr: boolean;
    onGenerarQr: () => void;
    onLimpiarSeleccion: () => void;
}

export const CatalogoInventarioAcciones = ({
    visualizacion,
    onCambiarVisualizacion,
    textoAnadir,
    onAnadir,
    seleccionados,
    generandoQr,
    onGenerarQr,
    onLimpiarSeleccion,
}: Props): JSX.Element => (
    <>
        {seleccionados > 0 && (
            <>
                <Button
                    variant="contained"
                    disabled={generandoQr}
                    sx={{
                        color: `${COLORES_INVENTARIO.qrTexto} !important`,
                        background: COLORES_INVENTARIO.qr,
                        whiteSpace: "nowrap",
                        "&:hover": { background: COLORES_INVENTARIO.qrHover },
                    }}
                    startIcon={<IconQrcode size={18} />}
                    onClick={onGenerarQr}
                >
                    {generandoQr ? "Generando QR..." : `Generar QR (${seleccionados})`}
                </Button>
                <Tooltip title="Quitar selección">
                    <span>
                        <Button
                            variant="outlined"
                            size="small"
                            disabled={generandoQr}
                            onClick={onLimpiarSeleccion}
                            sx={{ minWidth: 0, px: 1 }}
                            aria-label="Quitar selección"
                        >
                            <IconX size={18} />
                        </Button>
                    </span>
                </Tooltip>
            </>
        )}

        <ToggleButtonGroup
            size="small"
            exclusive
            value={visualizacion}
            onChange={(_, v: VisualizacionInventario | null) => v && onCambiarVisualizacion(v)}
            aria-label="Visualización de productos"
        >
            <Tooltip title="Cuadrícula">
                <ToggleButton value="cuadricula" aria-label="cuadricula">
                    <IconLayoutGrid size={18} />
                </ToggleButton>
            </Tooltip>
            <Tooltip title="Tabla">
                <ToggleButton value="tabla" aria-label="tabla">
                    <IconTable size={18} />
                </ToggleButton>
            </Tooltip>
        </ToggleButtonGroup>

        <Button
            variant="contained"
            sx={{ color: "#fff", background: COLORES_INVENTARIO.primario, whiteSpace: "nowrap" }}
            endIcon={<IconSquarePlus size={18} />}
            onClick={onAnadir}
        >
            {textoAnadir}
        </Button>
    </>
);
